import { FunctionComponent, useState } from "react"
import { Button, Table } from "react-bootstrap"
import { EntityPass, Pass } from "../data/models.interface"
import { formatDate } from "../utils/AccessControlFormatter"
import { sortArray } from "../utils/ArrayUtils"
import EntityPassModal from "./EntityPassModal"

interface IEntityPassesSubForm {
	entityPasses: EntityPass[]
	setEntityPasses: (value: EntityPass[]) => any
	passes: Pass[]
}
const EntityPassesSubForm: FunctionComponent<IEntityPassesSubForm> = ({
	entityPasses: value,
	setEntityPasses: setValue,
	passes,
}) => {
	// this is which row is open in the modal; undefined means the modal is closed
	const [modalIndex, setModalIndex] = useState<number | null>(null)
	// sorting will call setValue with the items in a new order
	const sortBy = (sortProperty: string) => setValue(sortArray(value, sortProperty, "AUTO"))
	//
	return (
		<>
			<EntityPassModal
				onHide={() => setModalIndex(null)}
				entityPasses={value}
				setEntityPasses={setValue}
				index={modalIndex}
				passes={passes}
			/>
			<Table striped bordered hover size="sm">
				<thead>
					<tr>
						<th onClick={() => sortBy("passName")}>Pass</th>
						<th onClick={() => sortBy("startDate")}>Start Date</th>
						<th onClick={() => sortBy("endDate")}>End Date</th>
					</tr>
				</thead>
				<tbody>
					{value?.map((entityPass, i) => (
						<tr key={entityPass.passId} onClick={() => setModalIndex(i)}>
							<td>{entityPass.passName || entityPass.passId}</td>
							<td>{formatDate(entityPass.startDate)}</td>
							<td>{formatDate(entityPass.endDate)}</td>
						</tr>
					))}
					<tr>
						<td colSpan={10} className="text-center">
							<Button variant="outline-success" size="sm" onClick={() => setModalIndex(value?.length || 0)}>
								Add Pass
							</Button>
						</td>
					</tr>
				</tbody>
			</Table>
		</>
	)
}
export default EntityPassesSubForm
